/* Go Bon Prix : gpx-theme.js */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var CFG = window.GPX || {};
  var ROUTES = CFG.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', all: '/collections/all' };

  /* ---------- Prix (format français, espace insécable avant €) ---------- */
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Message éphémère ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'gpx-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Tiroirs (menu, panier) ---------- */
  function overlay() { return $('.gpx-overlay'); }
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay()) overlay().classList.add('is-open');
    document.body.classList.add('is-locked');
    var f = el.querySelector('button,a,input');
    if (f) f.focus({ preventScroll: true });
  }
  function closeDrawers() {
    $$('.gpx-drawer').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (overlay()) overlay().classList.remove('is-open');
    document.body.classList.remove('is-locked');
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-gpx-open]');
    if (open) {
      var target = document.getElementById(open.getAttribute('data-gpx-open'));
      if (target) { e.preventDefault(); openDrawer(target); }
      return;
    }
    if (e.target.closest('[data-gpx-close]')) closeDrawers();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- En-tête au défilement + retour en haut ---------- */
  var header = $('[data-gpx-header]'), toTop = $('.gpx-totop'), ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.pageYOffset;
      if (header) header.classList.toggle('is-stuck', y > 10);
      if (toTop) toTop.classList.toggle('is-on', y > 800);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  if (toTop) toTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });

  /* ---------- Accordéons (FAQ, fiche produit) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.gpx-acc__b');
    if (!b) return;
    var open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
    var panel = document.getElementById(b.getAttribute('aria-controls'));
    if (panel) panel.classList.toggle('is-open', !open);
  });

  /* ---------- Pied de page : déroulant sur mobile uniquement ---------- */
  var mqMobile = window.matchMedia('(max-width: 749px)');
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.gpx-fcol__b');
    if (!b || !mqMobile.matches) return;
    var open = b.getAttribute('aria-expanded') === 'true';
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
    var p = b.nextElementSibling;
    if (p) p.classList.toggle('is-open', !open);
  });

  /* ---------- Afficher / masquer (mot de passe oublié) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gpx-toggle]');
    if (!t) return;
    e.preventDefault();
    var el = document.getElementById(t.getAttribute('data-gpx-toggle'));
    if (el) el.hidden = !el.hidden;
  });

  /* ---------- Tri des collections ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-gpx-autosubmit]')) e.target.form.submit();
  });

  /* ---------- Vente privée : compte à rebours sur une vraie date (heure de Paris) ---------- */
  function parisTime(y, mo, d, h, mi) {
    var guess = Date.UTC(y, mo - 1, d, h, mi);
    try {
      var p = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Paris', hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })
        .formatToParts(new Date(guess)).forEach(function (x) { p[x.type] = Number(x.value); });
      var asParis = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute);
      return guess - (asParis - guess);
    } catch (err) { return guess - 3600000; }
  }
  function parseEnd(raw) {
    raw = (raw || '').trim().toLowerCase();
    var m = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ t]+(\d{1,2})[:h](\d{2})?)?/);
    var y, mo, d;
    if (m) { y = m[1]; mo = m[2]; d = m[3]; }
    else {
      m = raw.match(/^(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{4})(?:[ à]+(\d{1,2})[:h](\d{2})?)?/);
      if (!m) return NaN;
      d = m[1]; mo = m[2]; y = m[3];
    }
    var h = m[4] !== undefined ? Number(m[4]) : 23;
    var mi = m[4] !== undefined ? Number(m[5] || 0) : 59;
    return parisTime(Number(y), Number(mo), Number(d), h, mi);
  }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function countdowns(scope) {
    $$('[data-gpx-countdown]', scope).forEach(function (cd) {
      if (cd._t) clearInterval(cd._t);
      var end = parseEnd(cd.getAttribute('data-gpx-countdown'));
      var section = cd.closest('.gpx-sec');
      function tick() {
        var diff = end - Date.now();
        if (isNaN(diff) || diff <= 0) { cd.hidden = true; if (section) section.hidden = true; return false; }
        cd.hidden = false; if (section) section.hidden = false;
        var s = Math.floor(diff / 1000);
        var q = function (k) { return cd.querySelector('[data-' + k + ']'); };
        q('d').textContent = Math.floor(s / 86400);
        q('h').textContent = pad(Math.floor(s % 86400 / 3600));
        q('m').textContent = pad(Math.floor(s % 3600 / 60));
        q('s').textContent = pad(s % 60);
        return true;
      }
      if (tick()) cd._t = setInterval(function () { if (!tick()) clearInterval(cd._t); }, 1000);
    });
  }
  window.gpxParseEnd = parseEnd;

  /* ---------- J-xx avant Noël ---------- */
  function noelCount() {
    var el = $('[data-gpx-noel-count]');
    if (!el) return;
    var now = new Date();
    if (now.getMonth() === 11 && now.getDate() === 25) { el.textContent = 'Joyeux Noël ! 🎄'; return; }
    var xmas = new Date(now.getFullYear(), 11, 25);
    if (now > xmas) { el.remove(); return; }
    el.textContent = 'J-' + Math.ceil((xmas - now) / 864e5) + ' avant Noël';
  }

  /* ---------- Date de livraison estimée ---------- */
  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  function workdays(d, n) {
    var x = new Date(d.getTime()), i = 0;
    while (i < n) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) i++; }
    return x;
  }
  function fmt(d) { return JOURS[d.getDay()] + ' ' + d.getDate() + ' ' + MOIS[d.getMonth()]; }
  function eta() {
    var els = $$('[data-gpx-eta]');
    if (!els.length) return;
    var c = CFG.delivery || { min: 2, max: 4, cutoff: 15 };
    var base = new Date();
    if (base.getHours() >= c.cutoff || base.getDay() === 0 || base.getDay() === 6) base = workdays(base, 1);
    var d1 = workdays(base, c.min), d2 = workdays(base, c.max);
    els.forEach(function (el) {
      el.innerHTML = 'Livraison offerte, reçue entre le <b>' + fmt(d1) + '</b> et le <b>' + fmt(d2) + '</b>.';
    });
  }

  /* ---------- Panier : ajout et tiroir ---------- */
  function setCount(n) { $$('[data-gpx-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', !n); }); }

  function renderDrawer(cart) {
    var body = $('[data-gpx-cart-items]');
    var foot = $('[data-gpx-cart-foot]');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="gpx-empty" style="padding:48px 0"><p>' + esc((CFG.strings || {}).emptyCart || 'Votre panier est vide') + '</p><a class="gpx-btn gpx-btn--accent" href="' + esc(ROUTES.all) + '">Voir les offres</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=180' : '';
      return '<div class="gpx-line">' +
        '<a class="gpx-line__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="76" height="76">' : '') + '</a>' +
        '<div><p class="gpx-line__t">' + esc(it.product_title) + '</p>' +
        (it.variant_title ? '<p class="gpx-line__v">' + esc(it.variant_title) + '</p>' : '') +
        '<div class="gpx-qty gpx-qty--sm"><button type="button" data-gpx-line="' + esc(it.key) + '" data-dir="-1" aria-label="Retirer un article">−</button>' +
        '<input type="number" value="' + it.quantity + '" min="0" data-gpx-line-input="' + esc(it.key) + '" aria-label="Quantité">' +
        '<button type="button" data-gpx-line="' + esc(it.key) + '" data-dir="1" aria-label="Ajouter un article">+</button></div>' +
        '<button class="gpx-line__rm" type="button" data-gpx-line-rm="' + esc(it.key) + '">Supprimer</button></div>' +
        '<div class="gpx-line__p">' + money(it.final_line_price) + '</div>' +
        '</div>';
    }).join('');
    if (foot) { foot.hidden = false; var t = $('[data-gpx-cart-total]'); if (t) t.textContent = money(cart.total_price); }
  }

  function refreshCart() {
    return fetch(ROUTES.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); renderDrawer(cart); return cart; })
      .catch(function () {});
  }

  function addToCart(id, qty, btn) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; }
    return fetch(ROUTES.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        if (!res.ok) { toast(res.data.description || 'Ce produit n’est plus disponible'); return; }
        if (btn) { btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1800); }
        refreshCart().then(function () { openDrawer($('#gpx-cart')); });
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        toast('Oups, la connexion a coupé. Réessayez.');
      });
  }

  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-gpx-quick]');
    if (quick) { e.preventDefault(); addToCart(quick.getAttribute('data-gpx-quick'), 1, quick); }
  });

  function changeLine(key, qty) {
    fetch(ROUTES.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart); setCount(cart.item_count);
        if (document.body.classList.contains('template-cart')) window.location.reload();
      });
  }
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-gpx-line]');
    if (q) {
      var key = q.getAttribute('data-gpx-line');
      var input = q.parentNode.querySelector('input');
      changeLine(key, Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(q.getAttribute('data-dir'), 10)));
      return;
    }
    var rm = e.target.closest('[data-gpx-line-rm]');
    if (rm) changeLine(rm.getAttribute('data-gpx-line-rm'), 0);
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('[data-gpx-line-input]');
    if (i) changeLine(i.getAttribute('data-gpx-line-input'), Math.max(0, parseInt(i.value, 10) || 0));
  });

  /* ---------- Quantité (fiche produit) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gpx-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-gpx-qty'), 10));
  });

  /* ---------- Fiche produit : galerie, variantes, stock, ajout ---------- */
  function gallery() {
    var main = $('[data-gpx-main-img]');
    if (!main) return;
    $$('[data-gpx-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-full');
        var im = t.querySelector('img'); main.alt = im ? im.alt : '';
        $$('[data-gpx-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  }

  function stockHtml(v) {
    var threshold = CFG.lowStock || 10;
    if (!v.available) return '';
    var tracked = v.inventory_management && v.inventory_policy === 'deny';
    var qty = v.inventory_quantity || 0;
    if (tracked && qty > 0 && qty <= threshold) {
      var pct = Math.max(6, Math.round(qty / threshold * 100));
      return '<div class="gpx-stock gpx-stock--low"><p class="gpx-stock__txt"><span class="gpx-stock__dot"></span>Vite, il n’en reste que ' + qty + '</p><div class="gpx-stock__bar"><span style="width:' + pct + '%"></span></div></div>';
    }
    return '<div class="gpx-stock"><p class="gpx-stock__txt"><span class="gpx-stock__dot"></span>Disponible, expédié sous 24 h</p></div>';
  }

  function product() {
    var root = $('[data-gpx-product]');
    if (!root) return;
    var dataEl = $('[data-gpx-variants]');
    var list = dataEl ? JSON.parse(dataEl.textContent) : [];
    var idInput = $('[data-gpx-variant]');
    var btn = $('[data-gpx-add]');
    var btnLabel = $('[data-gpx-add-label]');
    var main = $('[data-gpx-main-img]');
    var form = $('#gpx-product-form');

    function selected() {
      return $$('[data-gpx-opt]', root).filter(function (i) { return i.checked; })
        .sort(function (a, b) { return a.getAttribute('data-gpx-opt') - b.getAttribute('data-gpx-opt'); })
        .map(function (i) { return i.value; });
    }
    function update(fromUser) {
      var opts = selected();
      if (!opts.length) return;
      var v = list.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      opts.forEach(function (val, i) { var o = $('[data-gpx-opt-value="' + i + '"]'); if (o) o.textContent = val; });
      if (!v) { if (btn) btn.disabled = true; if (btnLabel) btnLabel.textContent = 'Combinaison indisponible'; return; }
      if (idInput) idInput.value = v.id;
      var has = v.compare_at_price && v.compare_at_price > v.price;
      var now = $('[data-gpx-now]'), was = $('[data-gpx-was]'), save = $('[data-gpx-save]'), notice = $('[data-gpx-notice]'), pctEl = $('[data-gpx-pct]');
      if (now) now.textContent = money(v.price);
      if (was) { was.textContent = has ? money(v.compare_at_price) : ''; was.hidden = !has; }
      if (save) { save.textContent = has ? money(v.compare_at_price - v.price) + ' d’économie' : ''; save.hidden = !has; }
      if (notice) notice.hidden = !has;
      if (pctEl) { pctEl.hidden = !has; if (has) pctEl.textContent = '−' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + ' %'; }
      if (btn) btn.disabled = !v.available;
      if (btnLabel) btnLabel.textContent = v.available ? CFG.strings.addToCart : CFG.strings.soldOut;
      if (v.featured_image && main && fromUser) main.src = v.featured_image.src;
      var bb = $('[data-gpx-buybar-price]'); if (bb) bb.textContent = money(v.price);
      var st = $('[data-gpx-stock]'); if (st) st.innerHTML = stockHtml(v);
      if (fromUser) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
    }
    $$('[data-gpx-opt]', root).forEach(function (i) { i.addEventListener('change', function () { update(true); }); });
    update(false);

    if (form && btn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
        addToCart(idInput.value, q, btn);
      });
    }

    var bar = $('[data-gpx-buybar]');
    if (bar && btn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { bar.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }, { rootMargin: '-80px 0px 0px 0px' }).observe(btn);
      bar.querySelector('button').addEventListener('click', function () { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); btn.click(); });
    }
  }

  /* ---------- Recommandations Shopify ---------- */
  function recommendations() {
    $$('[data-gpx-reco]').forEach(function (host) {
      var url = host.getAttribute('data-url');
      if (!url || host._done) return;
      host._done = true;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-gpx-reco]');
        if (fresh && fresh.querySelector('.gpx-card')) host.innerHTML = fresh.innerHTML;
        else host.remove();
      }).catch(function () { host.remove(); });
    });
  }

  /* ---------- Vus récemment ---------- */
  var RV_KEY = 'gpx:vus';
  function remember() {
    var el = $('[data-gpx-product]');
    if (!el) return;
    var h = el.getAttribute('data-handle'), list = [];
    try { list = JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { list = []; }
    list = list.filter(function (x) { return x !== h; });
    list.unshift(h);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
  }
  function recent() {
    $$('[data-gpx-recent]').forEach(function (host) {
      var grid = $('[data-gpx-recent-grid]', host);
      var cur = $('[data-gpx-product]');
      var curH = cur ? cur.getAttribute('data-handle') : null;
      var limit = parseInt(host.getAttribute('data-limit'), 10) || 5;
      var list = [];
      try { list = JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return; }
      list = list.filter(function (h) { return h !== curH; }).slice(0, limit);
      if (!list.length || !grid) return;
      var root = (ROUTES.root || '/').replace(/\/$/, '');
      Promise.all(list.map(function (h) {
        return fetch(root + '/products/' + encodeURIComponent(h) + '?section_id=gpx-card-ajax')
          .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (parts) {
        var html = parts.filter(Boolean).join('');
        if (!html.trim()) return;
        grid.innerHTML = html;
        host.hidden = false;
      });
    });
  }

  /* ---------- Suivi de colis ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-gpx-track]');
    if (!f) return;
    e.preventDefault();
    var nb = (f.querySelector('[name="nums"]').value || '').replace(/\s+/g, '').toUpperCase();
    if (!nb) return;
    window.open('https://t.17track.net/fr#nums=' + encodeURIComponent(nb), '_blank', 'noopener');
  });

  /* ---------- Démarrage ---------- */
  function init(scope) {
    countdowns(scope); noelCount(); eta(); gallery(); product();
    remember(); recommendations(); recent();
    if ($('#gpx-cart')) refreshCart();
  }
  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
